// The inbound nav-intent contract — what a host (the native drawer, or the web online_app)
// says to the Nav webview to REQUEST an open / close / toggle.
//
// The Nav webview is the SOLE owner of nav open/closed state (see
// plans/2026-07-15--nav-open-state-persistence.md). Hosts never mutate the nav directly:
// they request a change via these events, and reflect the resulting OnlineAppNav-open /
// OnlineAppNav-close signals the Nav emits back.
//
// Same shape as the session fan-out contract (constants/session_events.js): a namespaced
// DOM event dispatched at `window`. Two dispatchers, one listener (in nav.js):
//   • native  — broadcasts via WebViewRegistry: window.dispatchEvent(new Event("OnlineAppNav-openRequested"))
//   • web     — the online_app dispatches the same names as a same-document CustomEvent
//
// These strings are the cross-repo contract — they MUST be byte-identical in the iOS and
// Android apps. No echo loop: the "-*Requested" names are distinct from the outbound
// "-open" / "-close" names, so the Nav emitting an outbound signal cannot retrigger its own
// inbound listener.
export const NAV_TOGGLE_REQUESTED_EVENT = "OnlineAppNav-toggleRequested";
export const NAV_OPEN_REQUESTED_EVENT = "OnlineAppNav-openRequested";
export const NAV_CLOSE_REQUESTED_EVENT = "OnlineAppNav-closeRequested";
